import { observer } from 'mobx-react-lite';
import TableComponent from './TableComponent';
import { useStore } from '../../../app/stores/store';
import { useEffect } from 'react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import UnauthorizedMessage from '../../UnauthorizedMessage';

function MISProductionAndQualityReport() {
  const { RestorationStore, dashboardStore, commonStore } = useStore();

  useEffect(() => {
    RestorationStore.getTitleCode();
     // eslint-disable-next-line
  }, []);
  const dateBasedApiCall = async (fromDate?: string, toDate?: string) => {
    await RestorationStore.productionDateWiseReport(
      fromDate || '',
      toDate || '',
    );
  };
  return (
    <div>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('PHR01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('PHR01') && (
        <TableComponent
          name={'MIS Production & Quality Report'}
          dateBasedApiCall={dateBasedApiCall}
          DateInput={false}
          DualInut={true}
          downloadName={'MIS Production & Quality Report'}
        />
      )}
    </div>
  );
}
export default observer(MISProductionAndQualityReport);
